//-------------> C:\Users\shiva\Desktop\ew-sign-signpad\src\components\Page.tsx
import React, { useEffect, useRef, useState } from "react";
import { PaginationContainer } from "containers/PaginationContainer";

import { SignatureContainer } from "containers/SignatureContainer";
import { TextContainer } from "containers/TextContainer";
import { DateContainer } from "containers/DateContainer";
import { CheckboxContainer } from "containers/CheckboxContainer";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Dimensions } from "types";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
// import { Modal } from "semantic-ui-react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CommonPDFViewer from "./Common/CommonPDFviewer";
import { EmailContainer } from "containers/EmailContainer";
import { PicklistContainer } from "containers/PicklistContainer";

interface Props {
  page: any;
  dimensions?: Dimensions;
  updateDimensions: ({ width, height }: any) => void;
  allPages: any;
  goToPage: (pageNo: number) => void;
  isFetchingCordinatesData: any;
  setDrawingModalOpen: any;
  handleStartAndScrollElement: any;
  signatureIndicatorRef: any;
  updateViewportHeight: (height: number) => void;
  isDocumentActionComplete?: boolean;
  // updateViewportWidth: (width: number) => void;
}

const EDITOR_PAGE_WIDTH = 595.304;
const EDITOR_PAGE_HEIGHT = 841.889;

export const Page = ({
  page,
  dimensions,
  updateDimensions,
  allPages,
  goToPage,
  isFetchingCordinatesData,
  setDrawingModalOpen,
  handleStartAndScrollElement,
  signatureIndicatorRef,
  updateViewportHeight,
  isDocumentActionComplete = false,
  // updateViewportWidth,
}: Props) => {
  const canvasRefs = useRef<HTMLCanvasElement[]>([]);
  const renderTasks = useRef<{ [key: number]: any }>({});
  const [width, setWidth] = useState(595.303);
  const [height, setHeight] = useState(841.889);
  const [pageDimensionsMap, setPageDimensionsMap] = useState<{
    [key: number]: { width: number; height: number };
  }>({});
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const [isStartShown, setIsStartShown] = useState(true);
  const [arePagesRendered, setArePagesRendered] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fieldCounter, setFieldCounter] = useState(1);
  const [visiblePages, setVisiblePages] = useState<number[]>([]);

  const [mobileView, setMobileView] = useState(true);

  const allTextData = useSelector(
    (state: RootState) => state.textList.allTextData
  );
  const allEmailData = useSelector(
    (state: RootState) => state.emailList.allEmailData
  );
  const allDateData = useSelector(
    (state: RootState) => state.dateList.allDateData
  );
  const allPicklistData = useSelector(
    (state: RootState) => state.pickList.allPicklistData
  );
  const allCheckboxData = useSelector(
    (state: RootState) => state.checkboxList.allCheckboxData
  );
  const allSignatureData = useSelector(
    (state: RootState) => state.signatureList
  );
  const allCoordinatesData = useSelector(
    (state: RootState) => state.coordinatesList
  );
  const [isAllRequiredFieldsFilled, setIsAllRequiredFieldsFilled] =
    useState(false);
  const [isAllFieldsFilled, setIsAllFieldsFilled] = useState(false);
  const canShowStartButton =
    isStartShown &&
    arePagesRendered &&
    !isFetchingCordinatesData &&
    !isDocumentActionComplete;

  // const lastPageRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.innerWidth);
      setMobileView(window.innerWidth < 640);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const baseWidth = width || EDITOR_PAGE_WIDTH;
  const baseHeight = height || EDITOR_PAGE_HEIGHT;
  const scale = mobileView
    ? Math.min(1, Math.max(0.4, (deviceWidth - 24) / baseWidth))
    : 1;
  const scaledWidth = Math.round(baseWidth * scale);
  const scaledHeight = Math.round(baseHeight * scale);

  const lastPageRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (
      visiblePages.length === 0 ||
      allPages.length === 0 ||
      visiblePages.length !== allPages.length
    ) {
      setArePagesRendered(false);
      return;
    }

    let cancelled = false;
    let revealFrameId: number | null = null;
    let secondRevealFrameId: number | null = null;

    const renderPage = async (p: any, index: number) => {
      if (!p) return false;
      const _page = await p;
      const canvas = canvasRefs.current[index];
      if (!canvas) return false;
      const context = canvas.getContext("2d");

      // Get unscaled viewport (scale 1) to determine true page dimensions
      const unscaledViewport = _page.getViewport({ scale: 1 });
      const curPageW = unscaledViewport ? unscaledViewport.width : EDITOR_PAGE_WIDTH;
      const curPageH = unscaledViewport ? unscaledViewport.height : EDITOR_PAGE_HEIGHT;

      // Get viewport, scale 1.5 for crisp canvas rendering
      const viewport = _page.getViewport({ scale: 1.5 });
      if (!viewport) return false;

      canvas.width = viewport.width;
      canvas.height = viewport.height;
      setWidth(curPageW);
      setHeight(curPageH);
      setPageDimensionsMap((prev) => ({
        ...prev,
        [index]: { width: curPageW, height: curPageH },
      }));
      updateViewportHeight(mobileView ? Math.round(curPageH * scale) : curPageH);

      if (context) {
        if (renderTasks.current[index]) {
          try {
            renderTasks.current[index].cancel();
          } catch (err) { }
        }
        // Clear canvas before rendering
        context.clearRect(0, 0, canvas.width, canvas.height);
        const renderTask = _page.render({ canvasContext: context, viewport });
        console.log('4' + renderTask);

        renderTasks.current[index] = renderTask;
        try {
          await renderTask.promise;
        } catch (err: any) {
          if (
            err.name !== 'RenderingCancelledException' &&
            err.name !== 'RenderingCancelled' &&
            !err.message?.includes('Rendering cancelled')
          ) {
            console.error(err);
          }
          return false;
        }
        updateDimensions({ width: curPageW, height: curPageH });

        return true;
      }

      return false;
    };

    setArePagesRendered(false);

    const renderVisiblePages = async () => {
      const renderedPages = await Promise.all(
        visiblePages.map((pageNumber, index) => {
          if (allPages[pageNumber - 1]) {
            console.log('3' + pageNumber);

            return renderPage(allPages[pageNumber - 1], index);
          }

          return false;
        })
      );

      if (!cancelled && renderedPages.every(Boolean)) {
        revealFrameId = window.requestAnimationFrame(() => {
          secondRevealFrameId = window.requestAnimationFrame(() => {
            if (!cancelled) {
              setArePagesRendered(true);
            }
          });
        });
      }
    };

    renderVisiblePages();

    return () => {
      cancelled = true;
      if (revealFrameId !== null) {
        window.cancelAnimationFrame(revealFrameId);
      }
      if (secondRevealFrameId !== null) {
        window.cancelAnimationFrame(secondRevealFrameId);
      }
    };
  }, [visiblePages, allPages]);

  useEffect(() => {
    if (allPages.length > 0) {
      const pageNumbers = allPages.map((_, idx) => idx + 1);
      setVisiblePages(pageNumbers);
    }
  }, [allPages]);


  const updateFieldStatus = React.useCallback(() => {
    // console.log('allll date data' + JSON.stringify(allDateData));

    const requiredTextFieldsFilled = Object.values(allTextData).every(
      (pageData) =>
        (pageData as any[]).every((field) => !field.isRequired || field.value)
    );
    const requiredEmailFieldsFilled = Object.values(allEmailData).every(
      (pageData) =>
        (pageData as any[]).every((field) => !field.isRequired || field.value)
    );
    const requiredDateFieldsFilled = Object.values(allDateData).every(
      (pageData) =>
        (pageData as any[]).every(
          (field) => !field.isRequired || field.value !== "Invalid date"
        )
    );
    const requiredPicklistFieldsFilled = Object.values(allPicklistData).every(
      (pageData) => (pageData as any[]).every((field) => !field.isRequired || field.value)
    );
    const requiredSignatureFieldsFilled =
      allSignatureData.encodedImgData !== "";

    const allTextFieldsFilled = Object.values(allTextData).every((pageData) =>
      (pageData as any[]).every((field) => field.value)
    );
    const allPicklistFieldsFilled = Object.values(allPicklistData).every((pageData) =>
      (pageData as any[]).every((field) => field.value)
    );
    const allEmailFieldsFilled = Object.values(allEmailData).every((pageData) =>
      (pageData as any[]).every((field) => field.value)
    );
    const allDateFieldsFilled = Object.values(allDateData).every((pageData) =>
      (pageData as any[]).every((field) => field.value !== "Invalid date")
    );

    const allFieldsFilled =
      requiredTextFieldsFilled &&
      requiredDateFieldsFilled &&
      requiredPicklistFieldsFilled &&
      requiredSignatureFieldsFilled &&
      requiredEmailFieldsFilled &&
      allEmailFieldsFilled &&
      allTextFieldsFilled &&
      allPicklistFieldsFilled &&
      allDateFieldsFilled;

    setIsAllRequiredFieldsFilled(
      requiredEmailFieldsFilled &&
      requiredPicklistFieldsFilled &&
      requiredTextFieldsFilled &&
      requiredDateFieldsFilled &&
      requiredSignatureFieldsFilled
    );
    setIsAllFieldsFilled(allFieldsFilled);
  }, [allTextData, allDateData, allSignatureData, allEmailData, allPicklistData]);

  useEffect(() => {
    updateFieldStatus();
  }, [allTextData, allDateData, allSignatureData, allEmailData, allPicklistData, updateFieldStatus]);

  const handleNextClick = () => {
    console.log('page in handleNextClick ' + JSON.stringify(page));
    console.log('all page in handleNextClick ' + JSON.stringify(allPages));

    const { allCoordinateData } = allCoordinatesData;
    console.log("coordinates data length " + allCoordinateData.length);
    console.log("all date data @@" + JSON.stringify(allDateData));

    if (fieldCounter === allCoordinateData.length) {
      const allRequiredFieldsFilled = checkAllRequiredFieldsFilled();
      console.log('all requiredd fields filled ' + allRequiredFieldsFilled);

      if (allRequiredFieldsFilled) {
        console.log("logggggg" + showPopup);

        setShowPopup(true);
      } else {
        console.log("@@@ allRequiredFieldsFilled FALSE...");
        const emptyRequiredField =
          findEmptyRequiredField(allDateData, "Date") ||
          findEmptyRequiredField(allTextData, "Text") ||
          findEmptyRequiredField(allEmailData, "Email") ||
          findEmptyRequiredField(allPicklistData, "PickList") ||
          findEmptyRequiredSignatureField(allSignatureData.allSignatureData);

        if (emptyRequiredField) {
          console.log("Scrolling to empty required field:", JSON.stringify(emptyRequiredField));
          handleStartAndScrollElement(emptyRequiredField);
        }

      }
    } else {
      console.log("field counter" + fieldCounter);

      const { allCoordinateData } = allCoordinatesData;
      const nextField = allCoordinateData[fieldCounter];

      if (nextField) {
        console.log("Scrolling to next field:", JSON.stringify(nextField));
        handleStartAndScrollElement(nextField);
      } else {
        console.warn("No next field found for counter:", fieldCounter);
      }

      setFieldCounter((fieldCounter) => fieldCounter + 1);
    }

    //  else {
    //   console.log("field counter" + fieldCounter);
    //   handleStartAndScrollElement();
    //   setFieldCounter((fieldCounter) => fieldCounter + 1);
    // }
  };

  const findEmptyRequiredField = (data: any, fieldType: string) => {
    for (const pageData of Object.values(data)) {
      console.log('pageData' + JSON.stringify(pageData));

      for (const field of pageData as any[]) {
        console.log('page data field' + JSON.stringify(field));

        if (field.isRequired && (field.value === "" || field.value === 'Invalid date')) {
          console.log('qwertyuioihgfdsasdfghnjm');

          console.log('fields checking' + JSON.stringify({ ...field, fieldType }));

          return { ...field, fieldType };
        }
      }
    }
    return null;
  };

  const findEmptyRequiredSignatureField = (data: any) => {
    if (allSignatureData.encodedImgData === "") {
      console.log('fields checking signature' + JSON.stringify(allSignatureData.allSignatureData));

      for (const pageData of Object.values(data)) {
        for (const field of pageData as any[]) {
          console.log('sigantureee fields' + JSON.stringify({ ...field }));

          return { ...field };
        }
      }

      // return { fieldType: "Signature", isRequired: true, value: "" };
    }
    return null;
  };

  const checkAllRequiredFieldsFilled = () => {
    const requiredTextFieldsFilled = Object.values(allTextData).every(
      (pageData) =>
        (pageData as any[]).every((field) => !field.isRequired || field.value)
    );
    const requiredEmailFieldsFilled = Object.values(allEmailData).every(
      (pageData) =>
        (pageData as any[]).every((field) => !field.isRequired || field.value)
    );
    const requiredPicklistFieldsFilled = Object.values(allPicklistData).every(
      (pageData) =>
        (pageData as any[]).every((field) => !field.isRequired || field.value)
    );
    const requiredDateFieldsFilled = Object.values(allDateData).every(
      (pageData) =>
        (pageData as any[]).every(
          (field) => !field.isRequired || field.value !== "Invalid date"
        )
    );

    let requiredSignatureFieldsFilled = false;
    if (allSignatureData.encodedImgData !== "") {
      requiredSignatureFieldsFilled = true;
    }

    // const requiredCheckboxFieldsFilled = Object.values(allCheckboxData).every(pageData =>
    //   (pageData as any[]).every(field => !field.isRequired || field.value)
    // );

    console.log("requiredTextFieldsFilled" + requiredTextFieldsFilled);
    console.log("requiredDateFieldsFilled" + requiredDateFieldsFilled);

    // return requiredTextFieldsFilled && requiredDateFieldsFilled && requiredCheckboxFieldsFilled;
    return (
      requiredEmailFieldsFilled &&
      requiredTextFieldsFilled &&
      requiredDateFieldsFilled &&
      requiredPicklistFieldsFilled &&
      requiredSignatureFieldsFilled
    );
  };
  // console.log("width => ", width);
  // console.log("height => ", height);

  return (
    <>
      <Modal
        isOpen={showPopup}
        onClosed={() => setShowPopup(false)}
        centered
        className="modal-container"
        toggle={() => setShowPopup(false)}
        fade={false}
        size={"large"}
      >
        {/* <ModalHeader>All Required Fields Filled</ModalHeader> */}
        <ModalBody>
          <div>
            <p>You have filled all the required fields , Please submit the document</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            onClick={() => {
              setShowPopup(false);
            }}
            className="btn custom-btn1 text-dark bg-secondary"
          >
            Close
          </button>
        </ModalFooter>
      </Modal>
      <div
        ref={signatureIndicatorRef}
        // className="signature-indicator"
        onClick={() => {
          if (!canShowStartButton) {
            return;
          }

          setIsStartShown(false);
          setFieldCounter(1);
          handleStartAndScrollElement();
        }}
      >
        {canShowStartButton ? (
          <div className="signature-indicator">Start</div>
        ) : (
          <div className="next-hidden"></div>
        )}
      </div>
      <div
        style={
          mobileView
            ? {
                position: "relative",
                width: "100%",
                paddingTop: "8px",
                paddingBottom: "24px",
              }
            : { position: "relative", overflow: "hidden", top: "0" }
        }
        className="pdf-viewer-container"
      >
        {mobileView ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflow: "visible",
            }}
          >
            {visiblePages.map((pageNumber, index) => {
              const pW = pageDimensionsMap[index]?.width || width || EDITOR_PAGE_WIDTH;
              const pH = pageDimensionsMap[index]?.height || height || EDITOR_PAGE_HEIGHT;
              const pScale = mobileView
                ? Math.min(1, Math.max(0.4, (deviceWidth - 24) / pW))
                : 1;
              const pScaledW = Math.round(pW * pScale);
              const pScaledH = Math.round(pH * pScale);

              return (
              <div
                key={pageNumber}
                style={{
                  width: `${pScaledW}px`,
                  height: `${pScaledH}px`,
                  marginBottom: "16px",
                  position: "relative",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  borderRadius: "4px",
                  overflow: "hidden",
                  backgroundColor: "#ffffff",
                }}
                ref={
                  pageNumber === visiblePages[visiblePages.length - 1]
                    ? lastPageRef
                    : null
                }
              >
                <div
                  style={{
                    width: `${pW}px`,
                    height: `${pH}px`,
                    transform: `scale(${pScale})`,
                    transformOrigin: "top left",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                >
                  <canvas
                    ref={(el) => (canvasRefs.current[index] = el!)}
                    style={{
                      width: `${pW}px`,
                      height: `${pH}px`,
                      display: "block",
                      backgroundColor: "#ffffff",
                    }}
                  />
                  <SignatureContainer
                    page={allPages[pageNumber - 1]}
                    addDrawing={() => setDrawingModalOpen(true)}
                    isFetchingCordinatesData={isFetchingCordinatesData}
                  />
                  <TextContainer
                    page={allPages[pageNumber - 1]}
                    isFetchingCordinatesData={isFetchingCordinatesData}
                  />
                  <DateContainer
                    page={allPages[pageNumber - 1]}
                    isFetchingCordinatesData={isFetchingCordinatesData}
                  />
                  <CheckboxContainer
                    page={allPages[pageNumber - 1]}
                    isFetchingCordinatesData={isFetchingCordinatesData}
                  />
                  <EmailContainer
                    page={allPages[pageNumber - 1]}
                    isFetchingCordinatesData={isFetchingCordinatesData}
                  />
                  <PicklistContainer
                    page={allPages[pageNumber - 1]}
                    isFetchingCordinatesData={isFetchingCordinatesData}
                  />
                </div>
              </div>
            );})}

            {!isStartShown && !isDocumentActionComplete && arePagesRendered && !isFetchingCordinatesData && (
              <div
                ref={signatureIndicatorRef}
                className="signature-indicator-next"
                onClick={handleNextClick}
              >
                <span>
                  <i className="fa-solid fa-circle-arrow-down"></i>{" "}
                  {isAllFieldsFilled ? "Finish" : "Next"}
                </span>
              </div>
            )}
          </div>
        ) : (
          <TransformWrapper
            maxScale={2.5}
            initialScale={1}
            centerZoomedOut
            disablePadding
            wheel={{ disabled: true }}
            doubleClick={{ disabled: true }}
          >
            <TransformComponent>
              <div style={{ overflow: "visible" }}>
                {visiblePages.map((pageNumber, index) => {
                  const pW = pageDimensionsMap[index]?.width || width || EDITOR_PAGE_WIDTH;
                  const pH = pageDimensionsMap[index]?.height || height || EDITOR_PAGE_HEIGHT;

                  return (
                  <div
                    style={{
                      width: `${pW}px`,
                      minWidth: `${pW}px`,
                      height: `${pH}px`,
                      marginBottom: "20px",
                      position: "relative",
                    }}
                    key={pageNumber}
                    ref={
                      pageNumber === visiblePages[visiblePages.length - 1]
                        ? lastPageRef
                        : null
                    }
                  >
                    <canvas
                      ref={(el) => (canvasRefs.current[index] = el!)}
                      style={{
                        width: `${pW}px`,
                        height: `${pH}px`,
                        display: "block",
                        borderRadius: "5px",
                        boxShadow: "0 2px 5px gray",
                      }}
                    />
                    <SignatureContainer
                      page={allPages[pageNumber - 1]}
                      addDrawing={() => setDrawingModalOpen(true)}
                      isFetchingCordinatesData={isFetchingCordinatesData}
                    />
                    <TextContainer
                      page={allPages[pageNumber - 1]}
                      isFetchingCordinatesData={isFetchingCordinatesData}
                    />
                    <DateContainer
                      page={allPages[pageNumber - 1]}
                      isFetchingCordinatesData={isFetchingCordinatesData}
                    />
                    <CheckboxContainer
                      page={allPages[pageNumber - 1]}
                      isFetchingCordinatesData={isFetchingCordinatesData}
                    />
                    <EmailContainer
                      page={allPages[pageNumber - 1]}
                      isFetchingCordinatesData={isFetchingCordinatesData}
                    />
                    <PicklistContainer
                      page={allPages[pageNumber - 1]}
                      isFetchingCordinatesData={isFetchingCordinatesData}
                    />
                  </div>
                );})}

                {!isStartShown && !isDocumentActionComplete && arePagesRendered && !isFetchingCordinatesData && (
                  <div
                    ref={signatureIndicatorRef}
                    className="signature-indicator-next"
                    onClick={handleNextClick}
                  >
                    <span>
                      <i className="fa-solid fa-circle-arrow-down"></i>{" "}
                      {isAllFieldsFilled ? "Finish" : "Next"}
                    </span>
                  </div>
                )}
              </div>
            </TransformComponent>
          </TransformWrapper>
        )}
      </div>
    </>
  );
};
